import React from 'react';

import { ThemeProvider } from '@mui/material/styles';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
// eslint-disable-next-line import/no-named-as-default
import { BrowserRouter as Router } from 'react-router-dom';

import { App } from './App';
import theme from './Theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 3,
      staleTime: 10000
    }
  }
});
if (typeof window != 'undefined') {
  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Router>
            <App />
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}
